import {AfterViewInit, Component,  OnDestroy, Input, OnInit} from '@angular/core';
import {StreamsService}  from "../../services/streams.service";
 import {PanelVisibilityService} from '../../services/panel-visibility.service'
import {StreamProject, StreamAccessKey} from "../../interfaces";
import { ClipboardService } from 'ngx-clipboard'
import { NbGlobalPosition, NbDialogService, NbToastrService } from '@nebular/theme';
 import {visibilityPanelAnimation} from '../../classes/visibility-panel.animation'
  import {AuthService}  from "../../services/auth.service";


@Component({
  selector: 'app-stream-keys-control',
  templateUrl: './stream-keys-control.component.html',
  styleUrls: ['./stream-keys-control.component.scss'],
  animations: [visibilityPanelAnimation]
})
export class StreamKeysControlComponent implements OnInit, OnDestroy{


   
  @Input() stream: StreamProject

  levelLoading:boolean = false
  subscribeGetLevel: any = null
  subscribeGetAllKeys: any = null
  subscribeUploadKeys: any = null
  subscribeGenerateKeys: any = null
  keysOn:boolean = false
  keyGeneratorQuantity: any = 0
  accessKeys: any = []
  keysUploadDisabled:boolean = false
  accessLevels: any[] = [

    {text: "Відкрита трансляція", level: 0},
    {text: "Доступ за паролем", level: 1},
    {text: "Доступ після оплати", level: 2}

  ]

  streamAccessLevel: any = 0


   constructor(
    public streamsService: StreamsService,
    private _clipboardService: ClipboardService,
    private toastrService: NbToastrService,
    private dialogService: NbDialogService,
    public panelVisibility: PanelVisibilityService,
    public authService : AuthService

    ){
  }
 

  get keysCount(){
	let x = 0;

	for(let k of this.accessKeys){
	  x = x + (k.keys?.length || 0)
	}
  	return x 
  }

  openModal(content, e) {
    e.stopPropagation()
 	
    this.dialogService.open(content,{
	closeOnBackdropClick:false,
 	closeOnEsc:false, hasScroll: true} )
  }
  
  openRemoveModal(content, e) {
    e.stopPropagation()
 	
    this.dialogService.open(content,{hasScroll: true} )
  }
  
  clearAllKeys(ref){

	ref.close()

    this.levelLoading = true
    this.streamsService.clearAllAccessKeys(this.stream._id).subscribe((keys:StreamAccessKey[])=>{
      
	this.accessKeys = []
      this.levelLoading = false

      this.toastrService.show('','Ключі видалені',{
        status: 'success',
        icon:'',
        position: <NbGlobalPosition>'bottom-right'
          })

    },()=>{

      this.levelLoading = false
      
      this.toastrService.show('','Сталася помилка сервера',{
        status: 'danger',
        icon:'',
        position: <NbGlobalPosition>'bottom-right'
          })
    })
  }
 

  genereteKeys(ref){
	ref.close()

    if( this.keyGeneratorQuantity > 0){
      this.levelLoading = true
	if(this.subscribeGenerateKeys){

	this.subscribeGenerateKeys.unsubscribe()
	}
      this.subscribeGenerateKeys = this.streamsService.generateAccessKeys(this.stream._id, this.keyGeneratorQuantity)
      .subscribe((keys:StreamAccessKey[])=>{
         var temp = {time: keys[0].created, keys:[]}
       
       
        for(let key of keys){
          temp.keys.push(key)
        }
        this.accessKeys.push(temp) 

        this.levelLoading = false
         
        this.toastrService.show('','Ключі створені',{
          status: 'primary',
          icon:'',
          position: <NbGlobalPosition>'bottom-right'
            })
        this.keyGeneratorQuantity = 0
      },(error)=>{
        this.levelLoading = false
      
        this.toastrService.show('','Сталася помилка сервера',{
          status: 'danger',
          icon:'',
          position: <NbGlobalPosition>'bottom-right'
            })
      })
   } else {
         
        this.toastrService.show('','Кількість повинна бути більше нуля',{
          status: 'danger',
          icon:'',
          position: <NbGlobalPosition>'bottom-right'
            })
   }
   
  }


  loadKeysFromList(keysInput,ref){
   this.keysUploadDisabled = true
	let text = keysInput.value;
		var re = new RegExp('^[a-zA-z0-9-.@_/\n]+$');

		 if(!re.test(text)){
		 this.toastrService.show('','Неправильний формат',{
			status: 'danger',
			icon:'',
			position: <NbGlobalPosition>'bottom-right'
			  })
		      this.keysUploadDisabled = false
                   return
		}

		let items = text.split(/\n/).filter(x=>!!x.trim())
		let keys = []
		for(let item of items){

			if(item.length >100){

 			this.toastrService.show('','Неправильний формат',{
			status: 'danger',
			icon:'',
			position: <NbGlobalPosition>'bottom-right'
			  })
					      this.keysUploadDisabled = false
                  	 return

			}

			if(!keys.includes(item)){

				keys.push(item)
			}
		}
 

				      this.keysUploadDisabled = false

		let data = { keys}


		  if( this.subscribeUploadKeys){
		      this.subscribeUploadKeys.unsubscribe()
		      
		    }
		 this.subscribeUploadKeys =  this.streamsService.uploadListAccessKeys(this.stream._id, JSON.stringify(data))
      .subscribe((keys:StreamAccessKey[])=>{

		if(keys && keys.length){
			 var temp = {time: keys[0].created, keys:[]}
		       
		       
			for(let key of keys){
			  temp.keys.push(key)
			}
			this.accessKeys.push(temp) 
		}
 		 this.keysUploadDisabled = false
		 keysInput.value = ''
		 ref.close()
		this.toastrService.show('','Ключі додані',{
		  status: 'primary',
		  icon:'',
		  position: <NbGlobalPosition>'bottom-right'
		    })
 
	      },(error)=>{
 
	       this.keysUploadDisabled = false
		this.toastrService.show('','Сталася помилка сервера',{
		  status: 'danger',
		  icon:'',
		  position: <NbGlobalPosition>'bottom-right'
		    })
	      })
		 
	//()


  }


  loadKeys(){
 if( this.subscribeGetAllKeys){
      this.subscribeGetAllKeys.unsubscribe()
      
    }
    this.subscribeGetAllKeys = this.streamsService.getAllAccessKeys(this.stream._id).subscribe((keys: StreamAccessKey[])=>{

      var allKeys = []
      var temp = <any>{}
      var before = null
      for(let key of keys){
        if(before !== key.created){
          temp = <any>{time:key.created, keys: [] }
          allKeys.push(temp)
        }
        temp.keys.push(key)
        before = key.created
      }

      this.accessKeys = allKeys

    })

  }

 toggleKeysOn(){
	if(this.keysOn){
          this.setAccessLevel(1)
	}else{
          this.setAccessLevel(0)
	}
 }


  setAccessLevel(level){
    if(this.streamAccessLevel === level || level === 2){
      return
    }

    this.levelLoading = true

	if( this.subscribeGetLevel){
      this.subscribeGetLevel.unsubscribe()
     }
    this.subscribeGetLevel = this.streamsService.setAccessLevel(this.stream._id, level).subscribe((stream: StreamProject)=>{
      this.streamAccessLevel = stream.accessLevel
      this.stream.accessLevel = stream.accessLevel
      this.keysOn = this.stream.accessLevel === 1
      this.levelLoading = false
    },(error)=>{
      this.levelLoading = false
  
      this.toastrService.show('','Сталася помилка сервера',{
        status: 'danger',
        icon:'',
        position: <NbGlobalPosition>'bottom-right'
          })
    })
  }


  ngOnInit() { 
    this.streamAccessLevel = this.stream.accessLevel
    
	this.keysOn = this.stream.accessLevel === 1
     
    this.loadKeys()

  }

  
   ngOnDestroy() { 
    if( this.subscribeGetLevel){
      this.subscribeGetLevel.unsubscribe()
     }
    if( this.subscribeGetAllKeys){
      this.subscribeGetAllKeys.unsubscribe()
      
    }

   if( this.subscribeUploadKeys){
      this.subscribeUploadKeys.unsubscribe()
      
    }

	if(this.subscribeGenerateKeys){

	this.subscribeGenerateKeys.unsubscribe()
	}
    //subscribeGetAllKeys
   }
 

   


   copyAllKeysToClipboard(ref){
    this._clipboardService.copy(ref.innerText)



    this.toastrService.show('','Скопійовано в буфер обміну',{
      status: 'primary',
      icon:'',
      position: <NbGlobalPosition>'bottom-right'
        })
   }
   
   downloadAllKeysInTxt(ref){
      this.saveTextAsFile( ref.innerText, `${this.stream.streamKey}_keys.txt`)
   }


     saveTextAsFile (data, filename){

    if(!data) {
        console.error('Console.save: No data')
        return;
    }

    if(!filename) filename = 'file.txt'
	
	 

    var blob = new Blob([data], {type: 'text/plain'}),
        e    = document.createEvent('MouseEvents'),
        a    = document.createElement('a')
 

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, filename);
        }
        else{
          var e = document.createEvent('MouseEvents'),
              a = document.createElement('a');

          a.download = filename;
          a.href = window.URL.createObjectURL(blob);
          a.dataset.downloadurl = ['text/plain', a.download, a.href].join(':');
         /* e.initEvent('click', true, false, window,
              0, 0, 0, 0, 0, false, false, false, false, 0, null); */
		e.initEvent('click')
          a.dispatchEvent(e);
        }
  }

 

  
}
